import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      selectIcon: {
        width: 24,
        height: 24,
        color: sicrediColor.primarySicredi,
      },
      dateField: {
        cursor: 'pointer',
      },
      dateFieldAdornment: {
        color: sicrediColor.primarySicredi,
        marginLeft: theme.spacing(-3),
        pointerEvents: 'none',
      },
    }),
  { name: 'ListagemLoginsFiltros' }
);
